import { createApolloClient } from '@shared/apollo/client';

/** This brand's GraphQL endpoint; the maintenance screen probes it while the API is down. */
export const GRAPHQL_URL: string = import.meta.env.VITE_GRAPHQL_API_URL || 'https://api.tippingiq.com/graphql';

export const client = createApolloClient(GRAPHQL_URL);
